import React from 'react';
import { Toggle } from '@components/basics/toggle';
import { Button } from '@components/main-components/button/Button';
import { useAuth } from '@context/auth/base';
import { MediaQuery } from '@context/mediaQuery';
import { ModalContext } from '@context/modal';
import { useGetNotified } from '../useGetNotified';

export function GetNotifiedTogglePanel({
  artistId,
  userId,
  subscribeToggled,
  toggleSubscribe,
}: {
  userId: string;
  artistId: string;
  subscribeToggled: boolean;
  toggleSubscribe: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const { authUser } = useAuth();
  const isOwner = authUser?.id === userId;
  const { isSubscribedToArtist, isEmailSet } = useGetNotified({ artistId, userId });

  const showSubscribed = isSubscribedToArtist && isEmailSet;

  const handleToggleSubscribe = () => {
    toggleSubscribe(prev => !prev);
  };

  if (isOwner || showSubscribed) {
    return null;
  }

  return (
    <div className="w-full px-6">
      <div className="border-b border-solid border-base200" />
      <div className="flex items-center justify-between pt-4">
        <div className="flex flex-col">
          <p className="mb-1 text-base-l font-semibold text-base800">Subscribe to artist</p>
          <p className="text-base-m text-base600">Receive notification on new drops</p>
        </div>
        <Toggle onCheckedChange={handleToggleSubscribe} checked={subscribeToggled} />
      </div>
    </div>
  );
}

export function GetNotifiedTogglePanelButton({
  artistId,
  userId,
  subscribeToggled,
}: {
  userId: string;
  artistId: string;
  subscribeToggled: boolean;
}) {
  const { closeCancelModal } = ModalContext.useContainer();
  const { tablet } = MediaQuery.useContainer();
  const {
    loading,
    needsVerification,
    isSubscribedToArtist,
    handleSubscribe,
    handleEmailVerification,
  } = useGetNotified({
    artistId,
    userId,
  });

  const onHandleDoneClick = () => {
    closeCancelModal();

    if (!subscribeToggled) {
      return;
    }

    if (needsVerification) {
      handleEmailVerification();
    }

    if (!isSubscribedToArtist) {
      handleSubscribe();
    }
  };

  return (
    <Button
      fullWidth={!tablet}
      className="mr-2"
      label="Done"
      variant="secondary"
      onClick={onHandleDoneClick}
      disabled={loading}
    />
  );
}
